<template>
    <div class="terms">
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-img :src="'https://artlesscms.actstudio.xyz/'+terms.cover.path" width="100%"></v-img>
                </v-col>
            </v-row>
        </v-container>

        <v-container>
            <v-row>
                <v-col>
                    <div class="terms-container" v-html="terms.text">
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>    
</template>

<script>
export default {
    data(){
        return{
            terms: {}
        }
    },
    beforeMount: function(){
        fetch('https://www.artlesscms.actstudio.xyz/api/singletons/get/terms?token=a15be93e9cdb43ca2b3778c2077c26')
        .then(data => data.json())
        .then(data => this.terms = data);
    },
    mounted: function(){
        var breadcrumbs = [
            {
                text: 'Home',
                link: '/',
                isLink: true
            },
            {
                text: 'Terms of Service',
                link: '/terms',
                isLink: false
            }
        ];
        this.$emit("updateStatus", breadcrumbs);

        gtag('config', 'UA-26953667-1', {
        'page_title' : 'Terms',
        'page_path': '/terms'
        });
    }
}
</script>